import React from 'react';
import { Skeleton as SkeletonMui } from '@mui/material';
export const Skeleton = ({ animation = 'pulse', height, width, variant = 'text', _sx = {}, className = '', dataTestId, }) => {
    return (React.createElement(SkeletonMui, { animation: animation, height: height, width: width, variant: variant, sx: _sx, className: className, "data-testid": dataTestId }));
};
